class LangProvider {
  static getConstants() {
    /**
     * WORKAROUND: Avoid crash in SSR
    if (typeof window !== 'undefined' && typeof window.navigator !== 'undefined') {
      if (navigator.language.includes('es-')) {
        return require('./es');
      } else {
        return require('./en');
      }
    }

    */
    return require('./es');
  }
}

export default LangProvider;
